/**
 * 功能: 报告展示页底部内容显示
 */

<template lang="pug">
  div
    footer(style='height: 120px;')
      .foot-layout.flex-between-center
        .flex-between-center
          a(href="/")
            img(src="@/images/logo_footer.svg" style="width:120px;height:52px")
          .info
            .link
              a(href="/") 关于头豹
              a(href="/") 法律声明
              a(href="/") 企业账号介绍
              a(href="#") 会员体系
              a(href="/") 头豹产品介绍
              a(href="/") 专家团队介绍
              a 客服电话：400-072-5588
            .copyright
              | ©2017~2019 南京宇观慧现信息科技有限公司 All rights reserved.
              a(href='http://beian.miit.gov.cn/' style='color: rgb(117,115,115);' target='_blank') 苏ICP备19021850号-1
        .mp
          img(src="@/images/mp.png" style="width:80px;height:80px")
</template>

<script>
export default {

}
</script>

<style scoped>
footer{min-width:1200px; background: #333;}
footer  a:hover{color:#fff !important}
footer .foot-layout{width: 1190px; height: 120px;margin:0 auto;}
footer .info{margin-left:40px}
footer .info .link{text-align:left}
footer .info .link a{font-size:1rem;letter-spacing: 1.5px;color:rgb(117,115,115);margin-right:24px}
footer .info .copyright{color:rgb(117,115,115);font-size:0.9rem; text-align:left;padding-top:6px;letter-spacing: 1.31px;}
.flex-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>
